export const productId = {
  ['LC_Perm_RI_SPFU_BPI']: 'HBMX_450',
  ['LC_Nuevas_Adv_BPI']: 'HBMX_451',
  ['LC_Perm_RI_SPFU_Prem_BPI']: 'HBMX_452',
  ['LC_Perm_RevIni_SPFU_BPI']: 'HBMX_465',
  ['LC_Perm_RS_SPFU']: 'HBMX_453',
  ['Sub_Rev_OH']: 'HBMX_456',
  ['LC_Perm_RS_Adva_BPI']: 'HBMX_454',
  ['LC_Perm_RS_Premier_BPI']: 'HBMX_455',
  ['LC_Recom_Rev_Adva_BPI']: 'HBMX_466',
  ['LC_Recom_Rev_Premier_BPI']: 'HBMX_467',
  ['Nva_Rev_OH']: 'HBMX_468',
  ['Simple_Nom_M']: 'HBMX_457',
  ['Simple_CP_M']: 'HBMX_458',
  ['Simple_Nom_A']: 'HBMX_459',
  ['Simple_CP_A']: 'HBMX_460',
  ['Simple_Nom_P']: 'HBMX_461',
  ['Simple_CP_P']: 'HBMX_462',
  ['Simple_CP']: 'HBMX_470',
  ['Simple_Nom']: 'HBMX_471',
  ['Simple_Nom_Saldos_P']: 'HBMX_472',
  ['Nva_TopUp']: 'HBMX_463',
  ['Nva_TopUp_CP']: 'HBMX_469',
  ['TopUp_AN_MB']: 'HBMX_473',
  ['TopUp_CP_MB']: 'HBMX_474',
  ['Simple_Nom_Mob']: 'HBMX_???',
  ['Simple_CP_Mob']: 'HBMX_???',
  ['Pasivos_AN_Mob']: 'HBMX_???',
  ['Pasivos_CP_Mob']: 'HBMX_???',
  ['TopUp_AN_Mob']: 'HBMX_???',
  ['TopUp_CP_Mob']: 'HBMX_???',
  ['Refill_Nom_Mob']: 'HBMX_???',
  ['Refill_CP_Mob']: 'HBMX_???',
  ['Simple_MenoresCP_Mob']: 'HBMX_???',
  ['Simple_MenoresAN_Mob']: 'HBMX_???',
};
